import React, { useState } from 'react'
import CustomCollapse from '../../../../../Components/Common/CustomCollapse';
import CustomSelect from "../../../../../Components/Common/CustomSelect";
import { sortOrderOption } from '../../../../../common/feedTypes';
import { sortTypeOption } from '../../../../../common/feedTypes';

function SortIcon() {
  return (
    <div className='avatar-xs flex-shrink-0 me-2'>
      <span className='avatar-title rounded bg-primary text-primary'>
        <i className='mdi mdi-sort-variant'></i>
      </span>
    </div>
  )
}

function SortCollapse({ idx, name, groupPath, relativePath, onRemove, onDuplicate,
  onPickGroup, onPickField, handleOperationSelectChange = () => { }, handleNameChange, canEdit }) {
    const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <CustomCollapse
      key={idx}
      icon={<SortIcon />}
      name={name}
      className={"sort-accordion"}
      toggler={"sort-" + idx}
      btn={"btn-soft-primary"}
      onRemove={onRemove}
      onDuplicate={onDuplicate}
      canEdit={canEdit}
      isCollapsed={isCollapsed}
      setIsCollapsed={setIsCollapsed}
      onChange={handleNameChange}
    >
      <div className='w-100 d-flex flex-wrap align-items-center gap-2'>
        Sort on field
        <button className='btn btn-primary dropdown-toggle fw-bold' type='button' onClick={onPickField} disabled={!canEdit}>
          {relativePath !== "" ? relativePath : "Pick a field"}
        </button>
        in
        <CustomSelect
          className='btn btn-primary dropdown-toggle fw-bold'
          tag="button"
          options={sortOrderOption}
          onChange={(item) => handleOperationSelectChange("type", item.value)}
          value={sortOrderOption[0].name}
          disabled={!canEdit}
        />
        as
        <CustomSelect
          className='btn btn-primary dropdown-toggle fw-bold'
          tag="button"
          options={sortTypeOption}
          onChange={(item) => handleOperationSelectChange("subType", item.value)}
          value={sortTypeOption[0].name}
          disabled={!canEdit}
        />
      </div>
    </CustomCollapse>
  )
}

export default SortCollapse
